import wireframeDropdown from '../assets/icons/wireframeDropdown.svg';
import WireframeInputField from './WireframeInputField';
import { type IconData } from '../types';

class WireframeDropdown extends WireframeInputField {
  initItems() {
    this.addDropdownItems();
    if (!this.label) {
      this.addLabel({ value: 'Label', position: 'outside' });
    }
    if (!this.placeholder) {
      this.addPlaceholder({
        value: 'Dropdown',
        state: 'text',
        iconRight: { prefix: 'fas', iconName: 'angle-down' } as IconData,
      });
    }
  }

  static iconSvg() {
    return wireframeDropdown;
  }

  static externalName(): string {
    return 'Dropdown';
  }
}

export default WireframeDropdown;
